import { Address } from './Address';
import { Order } from './Order';

export enum UserRole {
  Admin = 'Admin',
  Moderator = 'Moderator',
  User = 'User',
}

export enum UserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export type User = {
  id: string;
  name: string;
  email: string;
  surname: string;
  role: UserRole;
  status: UserStatus;
  profilePicture?: string;

  orders: Order[];
  addresses: Address[];
};
